import { render, staticRenderFns } from "./FScrollUpBtn.vue?vue&type=template&id=a2fc37c4&scoped=true&"
import script from "./FScrollUpBtn.vue?vue&type=script&lang=ts&"
export * from "./FScrollUpBtn.vue?vue&type=script&lang=ts&"
import style0 from "./FScrollUpBtn.vue?vue&type=style&index=0&id=a2fc37c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fc37c4",
  null
  
)

export default component.exports